import $ from 'jquery';
window.$ = window.jQuery = $;

require('../node_modules/jquery/dist/jquery.js');
require('../node_modules/popper.js/dist/umd/popper.js');
require('../node_modules/owl.carousel2/dist/owl.carousel.min.js');
require('../node_modules/bootstrap/dist/js/bootstrap.min.js');
require('../node_modules/jquery-ui/ui/version.js');
require('../node_modules/jquery-ui/ui/keycode.js');
require('../node_modules/jquery-ui/ui/unique-id.js');
require('../node_modules/jquery-ui/ui/widget.js');
require('../node_modules/jquery-ui/ui/widgets/accordion.js');
// require('../node_modules/jquery-ui/ui/widgets/checkboxradio.js');
// require('../node_modules/jquery-ui/ui/widgets/autocomplete.js');
// require('../node_modules/jquery-ui/ui/widgets/dialog.js');
// require('../node_modules/jquery-ui/ui/widgets/datepicker.js');
require('../node_modules/magnific-popup/dist/jquery.magnific-popup.min.js');
require('../node_modules/slick-carousel/slick/slick.min.js');
require('../node_modules/jquery-validation/dist/jquery.validate.min.js');

import commonQuote from "./components/common-quote";
import address from "./components/address";
import quickQuote from "./components/quick-quote";
import quote from "./components/quote";
import changePassword from "./components/changepassword";
import tracking from "./components/tracking";
import user from "./components/user";
import main from "./components/main";
import jqueryUi from "./components/plugins/jquery-ui";

console.log('test-test');
document.addEventListener("DOMContentLoaded", async () => {
    commonQuote();
    address();
    await quickQuote();
    quote();
    changePassword();
    tracking();
    user();
    main();
    jqueryUi();
});
